export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14029.a094cc35.jpg";